<template>
  <el-dialog v-model="formVisible" title="修改密码" @close="close" width="30%">
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="120px"
      class="userForm"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="原密码" prop="password">
            <el-input
              v-model="ruleForm.password"
              placeholder="请输入原密码"
              type="password"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="新密码" prop="newPassword">
            <el-input
              v-model="ruleForm.newPassword"
              placeholder="请输入新密码"
              type="password"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="确认密码" prop="password2">
            <el-input
              v-model="ruleForm.password2"
              placeholder="确认密码"
              type="password"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <h-button type="primary" @click="submitForm(ruleFormRef)">提交</h-button>
      <h-button @click="formVisible = false">取消</h-button>
    </template>
  </el-dialog>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
} from "vue";
import util from "@util/js";
import Validate from "@/utils/validate.js";
import { ElMessage } from "element-plus";
import { changePassword } from "@/api/user";
import _ from "lodash";
export default defineComponent({
  name: "changePassword",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const ruleFormRef = ref();
    const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      defaultPassword: "kzga110",
      formVisible: false,
      ruleForm: {
        password: "",
        newPassword: "",
        password2: "",
      },
      rules: {
        password: [
          {
            required: true,
            validator: validate.password,
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            validator: validate.password,
            trigger: "blur",
          },
        ],
        password2: [
          {
            required: true,
            validator: validate.password,
            trigger: "blur",
          },
        ],
      },
    });
    const refData = toRefs(state);

    console.log(validate);
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    // 保存表单数据
    const submitForm = (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (state.ruleForm.newPassword !== state.ruleForm.password2) {
          ElMessage.warning("密码不一致请重新输入");
          return false;
        }
        if (valid) {
          const form = _.cloneDeep(state.ruleForm);
          util.formatForm(form);
          console.log(form);
          Reflect.deleteProperty(form, "password2");
          let res = await changePassword(form);
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
          } else {
            ElMessage.error("操作失败");
          }
          close();
        } else {
          return false;
        }
      });
    };
    const close = () => {
      context.emit("update:modelValue", false);
    };

    return {
      ...refData,
      ruleFormRef,
      submitForm,
      close,
    };
  },
});
</script>
<style  lang='scss' scoped >
.margLeftLabel {
}
</style>